import React from 'react';
import { RichText } from 'prismic-reactjs';
import { PrismicAwardLandingHeader } from '../../types/prismic';
import styles from './landing-header.module.scss';
import ResponsivePlayer from '../base/ResponsivePlayer';

type ImageSize = 'md' | 'lg' | 'xl';

type Props = PrismicAwardLandingHeader & {
  partner_image_size?: ImageSize;
};

const LandingHeader = ({ data, partner_image_size = 'md' }: Props) => {
  const {
    header_video_url,
    header_video_thumbnail,
    header_image,
    header_label,
    header_description,
    header_partner_label,
    header_partner_image,
  } = data;

  const partnerStyle =
    partner_image_size === 'md'
      ? styles.partnerMd
      : partner_image_size === 'lg'
      ? styles.partnerLg
      : styles.partnerXl;

  return (
    <section className="bg-pink-tan full-height full-width no-overflow center">
      <div className={`inner-width inner-width-padding ${styles.container}`}>
        <div className={styles.content}>
          <article className={`${styles.copy} text-center`}>
            {header_video_url && (
              <ResponsivePlayer
                primarySrc={header_video_url}
                thumbnailSrc={header_video_thumbnail.url}
              />
            )}
            {!header_video_url && (
              <img
                src={header_image.url}
                alt={header_image.alt}
                className={styles.banner}
              />
            )}
            {header_label && <h2 className={styles.header}>{header_label}</h2>}
            <RichText render={header_description} />
            <div className={`${partnerStyle} column center`}>
              {header_partner_label && <p>{header_partner_label}</p>}
              {header_partner_image && (
                <img
                  src={header_partner_image.url}
                  alt={header_partner_image.alt}
                />
              )}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default LandingHeader;
